<template>
  <v-card :loading="prizes.status === contentStatus.loading">
    <v-card-title>
      Payouts
    </v-card-title>
    <v-card-text>
      <template v-if="prizes.entries.length > 0">
        <v-row
          class="prize-item"
          justify="space-between"
          v-for="prize in prizes.entries"
          :key="prize.identifier"
        >
          <v-col cols="auto">
            <span id="prize-name">{{ prize.name }}</span>
          </v-col>
          <v-col cols="auto">
            <span id="prize-amount">
              <template v-if="prize.amount"> 1 X {{ prize.amount }} </template>
              <template v-else>
                N/A
              </template>
            </span></v-col
          >
        </v-row>
      </template>
      <template v-else>
        <v-row>
          <v-col>
            No playouts found...
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "PrizesCard",
  inject: ["contentStatus"],
  props: {
    prizes: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
@import "css/variables";
#prize-name,
#prize-amount {
  font-size: 1.8rem;
}
::v-deep #skeleton .v-skeleton-loader__list-item {
  background: transparent;
}

.prize-item {
  background: $orange;
  border-radius: 20px;
  margin: 2px 0;
}
</style>
